import React from "react";

interface ExpandButtonProps {
    groupingType: string;
    icon: React.ReactNode;
    onClick?: () => void;
}

const ExpandButton: React.FC<ExpandButtonProps> = ({
    groupingType,
    icon,
    onClick = () => { }
}) => {
    return (
        <button
            className={`expand expand-${groupingType}`}
            onClick={onClick}
            title="View all"
            aria-label="View all"
        >
            {icon}
        </button>
    );
};

export default ExpandButton;